var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 87,
    viewBox: "0 0 90 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4648_3806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.275 45.4706H65.7417V61.7849C65.7417 64.6747 63.4168 67.0126 60.5137 67.0126H29.4748C26.585 67.0126 24.2469 64.6878 24.2469 61.7849V45.4706H20.7135C16.7729 45.4706 14.1196 40.65 17.653 37.0247L38.5645 15.7322C40.3378 13.8801 42.6627 13 45.0008 13C47.3389 13 49.6639 13.8801 51.516 15.7322L56.258 20.5529V16.297C56.258 14.4449 57.7817 13 59.6338 13H62.4446C64.2179 13 65.7417 14.4449 65.7417 16.297V30.2862L72.3355 37.0378C75.856 40.65 73.2946 45.4706 69.275 45.4706Z",
    fill: "#5926F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4648_3806",
    x: 0.274508,
    y: 0.602654,
    width: 89.451,
    height: 85.4636,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.32815
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.86275
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.34902 0 0 0 0 0.14902 0 0 0 0 0.941176 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4648_3806"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4648_3806",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeA);
export default __webpack_public_path__ + "static/media/Home_a.fbb237f9a0c5bae84bc7914bb8967459.svg";
export { ForwardRef as ReactComponent };